<template>
    <v-data-table
        :headers="lateHeaders"
        :loading="latesLoading"
        :items="lateList"
        :items-per-page="lateOptions.itemsPerPage"
        :server-items-length="totalLateItems"
        :options.sync="lateOptions"
        no-data-text="No lates"
        class="elevation-0 d-block"
        @update:options="getLateList"
        :footer-props="{'items-per-page-options': [5,10,15,20]}"
        @click:row="lateRowClick"
    >
        <template v-slot:item.date="{ item }">
            <div class="d-flex align-center">
                <v-icon class="mr-3">${{convertTypeOfHoliday('Late')}}</v-icon>
                {{Date.formatDate([item.date])}}
            </div>
        </template>
    </v-data-table>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'AppraisalLates',

        props: ['date', 'latesLoading', 'userId'],

        data () {
            return {
                lateOptions: {
                    page: 1,
                    itemsPerPage: 20,
                    sortBy: ['date'],
                    sortDesc: [true],
                    mustSort: false,
                    multiSort: false
                },
                lateList: [],
                totalLateItems: 0,
                getAcces: false
            }
        },
        computed: {
            lateHeaders () {
                const headers = [
                    {
                        text: 'Date',
                        align: 'left',
                        sortable: true,
                        value: 'date'
                    }
                ]
                return headers
            }
        },
        methods: {
            ...mapActions([
                'getLates'
            ]),
            outsideGetTrigger () {
                this.getAcces = true
                this.lateOptions.page = 1
                this.getLateList()
            },
            async getLateList () {
                if (!this.getAcces) return
                const queryData = {
                    EmployeeIds: this.userId,
                    Date: this.date,
                    pageSize: this.lateOptions.itemsPerPage,
                    pageNumber: this.lateOptions.page,
                    sortOrder: this.lateOptions.sortDesc[0] === true ? 'DESC' : this.lateOptions.sortDesc[0] === false ? 'ASC' : null,
                    sortField: this.lateOptions.sortBy[0] || null
                }
                try {
                    this.$emit('updateLatesLoading', true)
                    const lateResponse = await this.getLates(queryData)
                    this.lateList = lateResponse.data.items
                    this.totalLateItems = lateResponse.data.metadata.totalElements
                    this.$emit('updateLatesLoading', false)
                } catch (e) {
                    this.$emit('updateLatesLoading', false)
                }
            },
            convertTypeOfHoliday (typeOfHoliday) {
                return typeOfHoliday.toLowerCase().split(' ').join('')
            },
            lateRowClick (item) {
                this.$router.push({ name: 'editEmployeeLate', params: { id: item.id } })
            }
        }
    }
</script>
